const parseCsvCell = (line) => {
  const trimmed = line.trim();
  if (!trimmed) return '';
  const quoted = trimmed.match(/^"([^"]*)"/);
  if (quoted) return quoted[1].trim();
  const first = trimmed.split(',')[0];
  return first.replace(/^"|"$/g, '').trim();
};

export async function parsePartslinkCsv(file) {
  if (!file) return [];
  const text = await file.text();
  const lines = text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
  if (lines.length === 0) return [];

  const header = parseCsvCell(lines[0]).toLowerCase();
  const startIdx = header === 'partslink' ? 1 : 0;

  const values = [];
  for (let i = startIdx; i < lines.length; i += 1) {
    const val = parseCsvCell(lines[i]);
    if (val) values.push(val);
  }

  return [...new Set(values)];
}
